import { msg } from 'gt-react';
import { PresentationChartIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const ExecutiveSummaryPage = lazyRouteComponent(
  () => import('./ExecutiveSummaryPage'),
  'ExecutiveSummaryPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/executive-summary',
  staticData: {
    app: {
      nav: {
        label: msg('Executive Summary', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <PresentationChartIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        groupOrder: 61,
        order: 5,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: ExecutiveSummaryPage,
  loader: () => ({
    crumb: msg('Executive Summary', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
